import type { AuthRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { stringValueObject } from '@contexts/shared/domain';

export type CheckUserStatusInput = {
	token: string;
};

export type CheckUserStatusUseCase = UseCase<CheckUserStatusInput, string>;

export function checkUserStatusBuilder(authRepository: AuthRepository): CheckUserStatusUseCase {
	return async function checkUserStatus(input: CheckUserStatusInput): Promise<string> {
		const token = stringValueObject().validate('token', input.token);

		return authRepository.checkUserStatus(token);
	};
}
